import React from 'react';
import { TextField, Flex, Text, TextArea, Button } from "@radix-ui/themes";
import Icon from '@mdi/react';
import { mdiContentSave, mdiClose, mdiDelete } from '@mdi/js';
import { api } from '../services/api';
import { useStore } from '../store/store';

export const SidebarLoreEdit = (props) => {
    const [state, actions] = useStore();
    const [temporaryLore, setTemporaryLore] = React.useState(props.selectedLore);
    const [focusedField, setFocusedField] = React.useState(null);
    
    React.useEffect(() => {
        setTemporaryLore(props.selectedLore);
    }, [props.selectedLore]);

    const saveLore = async () => {
        try {
            // Save to API
            if(temporaryLore.new === true) {
                await api.createLoreItem(state.currentNovel.id, temporaryLore);
            } else {
                await api.updateLoreItem(temporaryLore.id, temporaryLore);
            }

            // Update the novels in the store
            const updatedNovels = state.novels.map(novel => {
                if (novel.lore) {
                    if (temporaryLore.new === true) {
                        // Add the new lore to the novel's lore array
                        return { ...novel, lore: [...novel.lore, temporaryLore] };
                    } else {
                        // Update the existing lore in the novel's lore array
                        const updatedLore = novel.lore.map(lore => 
                            lore.id === temporaryLore.id ? temporaryLore : lore
                        );
                        return { ...novel, lore: updatedLore };
                    }
                }
                return novel;
            });
            actions.setNovels(updatedNovels);
            
            // Update the current novel in the store if it exists
            if (state.currentNovel) {
                if (temporaryLore.new === true) {
                    // Add the new lore to the current novel's lore array
                    const updatedLore = [...(state.currentNovel.lore || []), temporaryLore];
                    
                    const updatedCurrentNovel = {
                        ...state.currentNovel,
                        lore: updatedLore
                    };
                    
                    actions.setCurrentNovel(updatedCurrentNovel);
                } else {
                    // Update the existing lore in the current novel's lore array
                    const updatedLore = state.currentNovel.lore?.map(lore => 
                        lore.id === temporaryLore.id ? temporaryLore : lore
                    ) || [];
                    
                    const updatedCurrentNovel = {
                        ...state.currentNovel,
                        lore: updatedLore
                    };
                    
                    actions.setCurrentNovel(updatedCurrentNovel);
                }
            }
            
            // Reset the new flag if it was a new lore item
            if (temporaryLore.new) {
                setTemporaryLore({...temporaryLore, new: false});
            }
        } catch (error) {
            console.error("Failed to save lore item:", error);
        }
    }

    const deleteLore = async () => {
        try {
            // Delete from API
            await api.deleteLoreItem(temporaryLore.id);
            
            // Update novels in the store by filtering out the deleted lore item
            const updatedNovels = state.novels.map(novel => {
                if (novel.lore) {
                    return {
                        ...novel,
                        lore: novel.lore.filter(lore => lore.id !== temporaryLore.id)
                    };
                }
                return novel;
            });
            actions.setNovels(updatedNovels);
            
            // Update the current novel in the store
            if (state.currentNovel && state.currentNovel.lore) {
                const updatedCurrentNovel = {
                    ...state.currentNovel,
                    lore: state.currentNovel.lore.filter(lore => 
                        lore.id !== temporaryLore.id
                    )
                };
                actions.setCurrentNovel(updatedCurrentNovel);
            }
            
            // Close the lore editor
            props.setSelectedLore(null);
        } catch (error) {
            console.error("Failed to delete lore item:", error);
        }
    }

    return (
        <div className='sidebar-sidebar'>
            <div style={{textAlign: 'right', cursor: 'pointer'}} onClick={() => props.setSelectedLore(null)}>
                <Icon path={mdiClose} color={'#FFFFFF50'} size={1} />
            </div>
            <div className="sidebar-form">
                <Flex direction="column" align={'start'}>
                    <Text size={"2"} className="sidebar-form-textInput-label">Name</Text>
                    {state.readOnly ? (
                        <div className="sidebar-form-textInput read-only-field">{temporaryLore?.name ?? ''}</div>
                    ) : (
                        <TextField.Root style={{width: "300px"}} className="sidebar-form-textInput" placeholder="Name" value={temporaryLore?.name ?? ''} variant="soft" onChange={(e) => {
                            setTemporaryLore({...temporaryLore, name: e.target.value});
                        }} />
                    )}
                </Flex>
                <br />
                <Flex direction="column" align={'start'}>
                    <Text size={"2"} as="div" className="sidebar-form-textInput-label">Description</Text>
                    {state.readOnly ? (
                        <div className="sidebar-form-textInput read-only-field sidebar-form-textInput-big">{temporaryLore?.description ?? ''}</div>
                    ) : (
                        <TextArea 
                            className={`sidebar-form-textInput sidebar-form-textInput-big`} 
                            placeholder="Name" 
                            value={temporaryLore?.description ?? ''} 
                            variant="soft" 
                            onFocus={() => setFocusedField('descr')}
                            onBlur={() => setFocusedField(null)}
                            onChange={(e) => {
                                setTemporaryLore({...temporaryLore, description: e.target.value});
                            }} 
                        />
                    )}
                </Flex>
            </div>
            {!state.readOnly && (
                <div>
                    <Flex justify={'between'} gap="20px">
                        <Button color="green" style={{width: '80%', marginTop: '20px', cursor: 'pointer'}} onClick={() => {saveLore();}
                        }>
                            <Icon path={mdiContentSave} size={1} />
                            Save Location
                        </Button>
                        <Button color="red" style={{width: 'calc(20% - 20px)', marginTop: '20px', cursor: 'pointer'}} onClick={() => {deleteLore();}
                        }>
                            <Icon path={mdiDelete} size={1} />
                        </Button>
                    </Flex>
                </div>
            )}
        </div>
    );
};

export default SidebarLoreEdit;